import { Component } from '@angular/core';
import { SharedDataService  } from '../services/shared-data.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { Subject } from 'rxjs';
import { JwtDecoderService } from '../services/jwt-decoder.service';
import { MerchantService } from '../services/merchant.service';

@Component({
    selector: 'app-auth',
    standalone: true,
    imports: [],
    templateUrl: './auth.component.html',
    styleUrl: './auth.component.css'
})
export class AuthComponent {

  private readonly _destroying$ = new Subject<void>();
  merchantName: string;

  fechaHora = new Date();
  opciones: any = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric'
  };
  formatoFechaHora = new Intl.DateTimeFormat('es-ES', this.opciones).format(this.fechaHora);


  constructor(
    private sharedDataService: SharedDataService,
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private jwtDecoderService: JwtDecoderService,
    private merchantService: MerchantService
  ) {}

  public ngOnInit() {
    console.log('AuthComponent ngOnInit');

    this.route.queryParams.subscribe((params) => {

      // Aquí puedes acceder a los parámetros de la URL
      console.log('params', params);

      if(!params || Object.keys(params).length === 0) {
        return;
      }
      
      // Si el usuario canceló el flujo en login de B2C, redirige a la raíz sin mostrar error
      const error = params['error'];
      if (error) {
        this.router.navigate(['/']);
        return;
      }

      // Valida que el código de autorización exista 
      const code = params['code'];
      if (!code || code === 'undefined') {
        this.router.navigate(['/']);
        return;
      }

      // this.queryParamCode = code;
      localStorage.setItem('intention', JSON.stringify(code));

      this.authService.exchangeCodeForToken(code).subscribe({
        next: (response: any) => {
          console.log('response', response);
          const accessToken = response.access_token;
          const id_token = response.id_token;
          this.processAuth(id_token, accessToken);
        },
        error: (error) => {
          console.error('Error:', error);
        }
      });
    });

    // this.sharedDataService.getMerchantName$().subscribe(
    //   (merchantName) => {
    //     localStorage.setItem('merchant_name', merchantName);
    //   }
    // );
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }

  /**
   * Procesa la autenticación del usuario, obteniendo datos del accessToken, registrando los datos necesarios en storage, 
   * y realizando llamada a api de merchant para obtener y setear los datos necesarios
   * @param accessToken 
   */
  processAuth(idToken: string, accessToken: string) {
    const decodedAccessToken = this.jwtDecoderService.decodeToken(accessToken);
    const decodedIdToken = this.jwtDecoderService.decodeToken(idToken);
    console.log("merchant_id", decodedIdToken.merchantId);

    localStorage.setItem('auth.access_token', accessToken);
    localStorage.setItem('auth.expires_on', decodedAccessToken.exp);
    localStorage.setItem('auth.merchant_id', decodedIdToken.merchantId);
    localStorage.setItem('auth.time_zone', decodedIdToken.userTimeZone);
    localStorage.setItem('auth.login', this.formatoFechaHora);

    const newURL = window.location.href.split('?')[0];
    history.replaceState({}, document.title, newURL);

    const today = new Date();
    const formattedStartDate = today.toISOString().split('T')[0] + 'T00:00:00Z';
    const formattedEndDate = today.toISOString().split('T')[0] + 'T23:59:59Z';

    localStorage.setItem('calendar.created_at_from', formattedStartDate);
    localStorage.setItem('calendar.created_at_to', formattedEndDate);

    // this.authToken = localStorage.getItem('auth.access_token');
    
    const merchantId = localStorage.getItem('auth.merchant_id');
    // Se obtienen datos de API Merchant
    this.merchantService.MerchantStateMachine(accessToken, merchantId).subscribe(
      (merchant) => {
        this.sharedDataService.setMerchantName(merchant.merchant_name);
        this.router.navigate(['/inicio']);
      }
    );
  }
}
